var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"title"},[_c('img',{attrs:{"src":require("../assets/img/icon/juxing.png"),"alt":"","srcset":""}}),_vm._v(" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }